import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-custom-tooltip__wrapper" }

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
    required: true
  }
},
  setup(__props) {



const displayTooltip = ref(false)

function getTooltip(el: Event) {
  displayTooltip.value = true
  const tooltip = el.target as HTMLElement
  const rect = tooltip.getBoundingClientRect()
  const tooltipTitle = tooltip.querySelector<HTMLElement>('.app-custom-tooltip__title')
  if (tooltipTitle) {
    tooltipTitle.style.cssText += `left:${rect.left + 42}px;top:${rect.top + 5}px;`
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onMouseenter: getTooltip,
    class: "app-custom-tooltip"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("span", {
        class: _normalizeClass(["app-custom-tooltip__title", displayTooltip.value && 'app-custom-tooltip__title--visible'])
      }, _toDisplayString(__props.title), 3)
    ])
  ], 32))
}
}

})